import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ReportForm from '../components/ReportForm';
import InfoSection from '../components/InfoSection';
import Footer from '../components/Footer';
import ParticleBackground from '../components/ParticleBackground';

const AbuseReportPage=()=> {
  const [isLoaded,setIsLoaded]=useState(false);

  useEffect(()=> {
    setIsLoaded(true);
  },[]);

  return (
    // Updated background to deep slate/blue
    <div className="min-h-screen bg-slate-950 relative overflow-hidden">
      <ParticleBackground />
      <AnimatePresence>
        {isLoaded && (
          <motion.div 
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.8}}
            className="relative z-10"
          >
            <Header />
            <HeroSection />
            <ReportForm />
            <InfoSection />
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AbuseReportPage;